module.exports = __webpack_public_path__ + "img/age-confirmation-bg.d1ef74a9.jpg";